/**
 * Module dependencies
 */
const React = require('react');
const { sanitizeHTML } = require('../../helpers/sanitizeHtml');
const Hotjar = require('../HotJar');

/**
* LandingView Component
*/
const OneColumnView = ({ page, siteId }) => (
  <div>
    <Hotjar siteId={siteId} traffic={{ from: 0, to: 100 }} />
    <section className="content">
      <div className="mesh-row one-column">
        <div className="mesh-col-l-12 mesh-row__content">
          <div
            className="inner-content"
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(page.content) }}
          />
        </div>
      </div>
    </section>
  </div>
);

module.exports = OneColumnView;
